import contactUs from './contactUs'
import leaveComment from './leaveComment'
import subscribe from './subscribe'

const forms = { contactUs, leaveComment, subscribe }

export default forms
